import styles from './index.module.scss';
import NaviNewLogoIcon from '@icons/NaviLogoIcon/NaviNewLogoIcon';
import Typography from '@primitives/Typography';
import Button from '@primitives/Button';
import { ExtensionHandler } from '@cp/utils/extension.utils';
import { UPDATE_EXTENSION_DEMO_PATH } from '@cp/src/layout/Routes';

const UpdateExtensionNudge = () => {
  const openExtensionsPage = () => {
    ExtensionHandler.focusChromeExtensionsPage();
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <NaviNewLogoIcon size="sm" />
        </div>
        <div className={styles.description}>
          <Typography variant={'p3'}>
            <b>New Version</b> of Chrome Extension has been released.
          </Typography>
          <Typography variant={'p3'}>
            To update, please{' '}
            <Button onClick={openExtensionsPage} variant="text">
              Click Here
            </Button>{' '}
            or{' '}
            <a
              className={styles.viewDemoAnchor}
              href={UPDATE_EXTENSION_DEMO_PATH}
              target={UPDATE_EXTENSION_DEMO_PATH}
            >
              View Demo
            </a>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default UpdateExtensionNudge;
